module.exports = __webpack_public_path__ + "img/9_91.2aea5fdc.png";